import { UserPermission, currentUserVar } from "_graphql/cache/auth";

import _ from "lodash";

export default function withPermissions<T = any>(roles: UserPermission[]) {
  const currentUser = currentUserVar();
  const permissions =
    JSON.parse(atob(currentUser?.broker_role?.privileges || btoa("[]"))) || [];
  return (val: T, alt?: T): T | null => {
    if (roles.length > 0) {
      if (_.intersection(roles, permissions || []).length > 0) {
        return val;
      }
      return alt ?? null;
    }
    return val;
  };
}
